const routes = [
    {
        path: "/availability/rooms",
        component: () => import("../pages/Index.vue"),
        meta: {
            isAuthenticated: true,
            permission: "housingbed_available"
        }
    },
    {
        path: "/my-housing-reservations/new",
        component: () => import("../pages/Student.vue"),
        meta: {

        }
    },
];

export default routes;
